import { render, staticRenderFns } from "./3dExplain.vue?vue&type=template&id=4557d150&scoped=true&"
import script from "./3dExplain.vue?vue&type=script&lang=js&"
export * from "./3dExplain.vue?vue&type=script&lang=js&"
import style0 from "./3dExplain.vue?vue&type=style&index=0&id=4557d150&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4557d150",
  null
  
)

export default component.exports